import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Navbar from '../components/Navbar/Navbar';
import InstalarApp from '../components/Button/InstalarApp';
import OnlineStatus from '../components/Utils/OnlineStatus';
import PrivateRoute from '../context/PrivateRoute';
import './MainLayout.css';
import { Outlet } from 'react-router-dom';

const AdminLayout = () => { 
    return (
      <PrivateRoute>
        <div className="main-layout">
            <Header />
            <Navbar/>
            <main className="container">
              <OnlineStatus/>
              <InstalarApp/>
              <Outlet/>
            </main>
            <Footer/>
        </div>
      </PrivateRoute>
    );
};
export default AdminLayout;